import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, ViewController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { AdvancedAnalyticsServices } from '../../../analytics/advanced-analytics-services';

/**
 * Generated class for the SelectBetweenDatetime page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-select-between-datetime',
  templateUrl: 'select-between-datetime.html',
})
export class SelectBetweenDatetime {
  title: any;
  cashs: any;
  uid_cash: any;
  date_first: any;
  date_last: any;
  date: any;
  cash_name: any;
  cash_uid: any;
  income_bool: boolean = false;
  cash_bool: boolean = false;
  show_alert: boolean = false;
  date_multi: boolean = true;
  select_future_dates: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public globals: Globals,
    public translate: TranslateService,
    public toastCtrl: ToastController,
    public advancedAnalyticsServices: AdvancedAnalyticsServices,) {

    this.title = this.navParams.get('title');
    this.cashs = this.navParams.get('cashs');
    this.date_first = this.navParams.get('date_first');
    this.date_last = this.navParams.get('date_last');
    this.uid_cash = this.navParams.get('uid_cash');
    this.cash_bool = this.navParams.get('cash_bool');
    this.income_bool = this.navParams.get('income_bool');
    this.date = this.navParams.get('date');
    if (this.navParams.get('date_multi') != undefined) {
      this.date_multi = this.navParams.get('date_multi');
    }
    if (this.navParams.get('select_future_dates') != undefined) {
      this.select_future_dates = this.navParams.get('select_future_dates');
    }

  }

  selectCash(value) {
    this.uid_cash = value;
  }

  //funcion que al guardar le pasamos los datos del modal a pagina anterior para que los trate
  save() {
    if (this.checkValidDate()) {//fechas ok dismiss
      if (this.cash_bool) {//caso necesita caja
        if (this.uid_cash != 'all') {
          var cash_split = this.uid_cash.split(';:;');
          this.cash_uid = cash_split[0];
          this.cash_name = cash_split[1];
        } else {
          this.cash_uid = this.uid_cash;
          this.cash_name = this.translate.instant('general-todos');
        }
      } else {//caso no necesita caja llenamos vacio
        this.cash_uid = '';
        this.uid_cash = '';
        this.cash_name = '';
      }

      //preparamos el data
      let data = {
        'cash_uid': this.cash_uid,
        'uid_cash': this.uid_cash,
        'cash_name': this.cash_name,
        'date_first': this.date_first,
        'date_last': this.date_last,
        'date': this.date
      };
      this.viewCtrl.dismiss(data);
    } else { //fechas mal lanzar toast
      if (this.date_multi) {
        let toast = this.toastCtrl.create({
          message: this.translate.instant('instant-selecciona-rango-fechas-correcto'),
          duration: 3000,
          position: 'top'
        });
        toast.present();
      } else {
        let toast = this.toastCtrl.create({
          message: this.translate.instant('general-selecciona-fecha-anterior-actual'),
          duration: 3000,
          position: 'top'
        });
        toast.present();
      }

    }
  }

  //funcion para validar que la fecha dada sea correcta
  checkValidDate() {
    if (this.date_multi) {
      if (this.date_first && this.date_last) {//mirar que las fechas existan en caso de poner dd/mm/aaaa --:--
        if (this.date_first <= this.date_last) {//mirar que la fecha inicial nunca sea superior a final
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      if (this.date) {//mirar que la fecha exista en caso de poner dd/mm/aaaa --:--
        if (this.select_future_dates == false) { //Solo comprobar que la fecha sea mayor que hoy si la variable es false
          if (this.date < moment().format('YYYY-MM-DD')) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      } else {
        return false;
      }
    }
  }
  
  onChange(){
    if(this.date_first <= "2021-05-15T00:00"){
      this.show_alert = true;
    } else {
      this.show_alert = false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/components/popups/select-between-datetime/select-between-datetime.ts